<template>
  <div>
    <add-button :loadData="loadData" :compatibleModelsOptions="compatibleModelsOptions"
                :isMotor="true"
                :organizationOptions="organizationOptions"/>

    <MotorFirmwareTable :tableData="tableData" @delete-motor-firmware="deleteMotorFirmWare" :loadData="loadData"
                        :loading="loading" :compatibleModelsOptions="compatibleModelsOptions"
                        :organizationOptions="organizationOptions"/>

    <pagination-bar :totalRecords="totalRecords" :current-page="currentPage" :page-size="pageSize"
                    @page-change="handlePageChange" @page-size-change="handlePageSizeChange"/>
  </div>
</template>

<script>
import AddButton from '@/views/ProductManage/ConfigManagement/components/Motor/FirmwareComponents/AddButton.vue';
import MotorFirmwareTable
  from '@/views/ProductManage/ConfigManagement/components/Motor/FirmwareComponents/MotorFirmwareTable.vue';
import PaginationBar from '@/components/PaginationBar.vue';
import {deleteFirmware, getFirmware, getOrganizationsData, getProductModelData, listToTree} from "@/api/api";

export default {
  data() {
    return {
      tableData: [], // 电机数据
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      loading: false, // 加载状态
      compatibleModelsOptions: [],  // 兼容型号选项
      organizationOptions: [],  // 组织选项
    };
  },
  mounted() {
    this.loadData();
    this.fetchMotorCompatibleModels();
    this.fetchOrganizationOptions();
  },
  methods: {
    async fetchMotorCompatibleModels() {
      try {
        const response = await getProductModelData(0, 0);
        this.compatibleModelsOptions = response.data;
      } catch (error) {
        this.$message.error(this.$t('ProductManage.ConfigManage.fetchDataFail'));
      }
    },
    async fetchOrganizationOptions() {
      try {
        const response = await getOrganizationsData();
        const treeData = listToTree(response.data);
        this.organizationOptions = this.transformOrganizationsData(treeData);
      } catch (error) {
        console.error(this.$t('ProductManage.ConfigManage.fetchOrganizationFailed'));
      }
    },
    transformOrganizationsData(treeData) {
      // 在这里实现 transformOrganizationsData 逻辑
      // 假设这里是个简单的例子
      return treeData.map(item => ({
        label: item.name,
        value: item.id,
        children: item.children ? this.transformOrganizationsData(item.children) : []
      }));
    },
    async deleteMotorFirmWare(motorFirmWare) {
      // 处理删除电机逻辑
      try {
        await deleteFirmware(motorFirmWare.firmware_id);
        await this.loadData();
      } catch (error) {
        // 处理错误，例如输出错误提示或进行其他处理
        console.error(this.$t('ProductManage.deleteDataFailed'));
      }
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
      this.loadData(); // 重新加载数据
    },
    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.loadData(); // 重新加载数据
    },
    async loadData() {
      this.isSearching = false;
      const page = this.currentPage;
      const pageSize = this.pageSize;
      this.loading = true; // 开始加载
      try {
        const data = await getFirmware(page, pageSize, {"type-eq": 0});

        // 先过滤数据，仅保留 type 为 1 的项
        const filteredData = data.data.filter(item => item.type === 0);
        // 按id降序排序
        filteredData.sort((a, b) => b.id - a.id);
        // 将从服务器获取的数据进行字段重命名
        this.tableData = filteredData.map(item => ({
          firmware_id: item.id,
          firmwareName: item.name,
          firmwareDescription: item.desc, // 根据值映射中文名称
          firmware: item.file,
          fileName: item.file_name,
          file_url: item.file_url,
          compatibleModel: item.productModels.map(model => model.name).join(', '),
          compatibleOrganization: item.organizations.map(org => org.name).join(', '),
        }));
        this.totalRecords = data.meta.total;
        this.currentPage = data.meta.current_page;
        this.pageSize = typeof data.meta
            .per_page === 'string' ? parseInt(data.meta
            .per_page, 10) : data.meta
            .per_page;

      } catch (error) {
        console.error(this.$t('ProductManage.loadDataFailed'));
      } finally {
        this.loading = false; // 加载结束
      }
    },
  },
  components: {
    AddButton,
    MotorFirmwareTable,
    PaginationBar,
  },
};
</script>
